import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 45.779 45.779"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M37.426 2.633H8.362C3.746 2.633 0 6.369 0 10.985v17.003c0 4.615 3.747 8.344 8.362 8.344h18.48l3.902 5.604a2.83 2.83 0 0 0 2.311 1.211 2.82 2.82 0 0 0 2.314-1.197l4.129-5.865a8.36 8.36 0 0 0 6.281-8.098V10.985a8.35 8.35 0 0 0-8.353-8.352m-21.995 19.57a2.72 2.72 0 0 1-2.726-2.717 2.72 2.72 0 0 1 2.726-2.716 2.72 2.72 0 0 1 2.726 2.716 2.72 2.72 0 0 1-2.726 2.717m7.463 0a2.72 2.72 0 0 1-2.726-2.717 2.72 2.72 0 0 1 2.726-2.716 2.72 2.72 0 0 1 2.725 2.716 2.72 2.72 0 0 1-2.725 2.717m7.463 0a2.72 2.72 0 0 1-2.727-2.717c0-1.499 1.221-2.716 2.727-2.716s2.726 1.217 2.726 2.716a2.72 2.72 0 0 1-2.726 2.717" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }